import { RegistrationHistoryTabName } from '@App/enum/registration-history-tab-name'
import { RegistrationStatus, RegistrationStatusAndFilters } from '@App/enum/registration-status'

export const regHistoryTabNamesAsRegistrationStatus = (
    tabName: RegistrationHistoryTabName
): RegistrationStatusAndFilters => {
    switch (tabName) {
        case RegistrationHistoryTabName.Pending:
            return { status: RegistrationStatus.pending, defaultFilters: [] }
        case RegistrationHistoryTabName.Completed:
            return { status: RegistrationStatus.processing, defaultFilters: ['accepted', 'rejected', 'superseded'] }
        case RegistrationHistoryTabName.NeedsAttention:
            return { status: RegistrationStatus.needs_attention, defaultFilters: ['processing'] }
        default:
            return { status: RegistrationStatus.processing, defaultFilters: [] }
    }
}
